import { SettingTaskAPI } from "../api";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';
export class SettingTask {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  get statusString() {
    let statusLabel = {
      draft: i18n.t('payment.wait_send'),
      pending: i18n.t('payment.wait_approval'),
      rejected: i18n.t('task.not_approve'),
      approved: i18n.t('task.approve')
    }
    return statusLabel[this.status]
  }
  get createdByFullName() {
    let res = "";
    if (this.createdBy) {
      res = `${this.createdBy.firstName} ${this.createdBy.lastName}`;
    }
    return res;
  }
  get updatedByFullName() {
    let res = "-";
    if (this.updatedBy) {
      res = `${this.updatedBy.firstName} ${this.updatedBy.lastName}`;
    }
    return res;
  }
  get createdAtDateFormat() {
    let res = "";
    if (this.createdAt) {
      res = `${moment(this.createdAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get updatedAtDateFormat() {
    let res = "-";
    if (this.updatedAt && this.updatedBy) {
      res = `${moment(this.updatedAt).format("DD-MM-YYYY")}`;
    }
    return res;
  }
  get typeName() {
    let res = ''
    let labels = {
      billing_setting: i18n.t('invoice.title'),
      area_accounting_product: i18n.t('bill.bill_price'),
    }
    if (this.type) {
      res = labels[this.type]
    } else {
      res = i18n.t('invoice.title')
    }
    return res
  }
  get actionString() {
    let res = ''
     // action_type = action_type
    let actionLabels = {
      add: i18n.t('action_type.add'),
      edit: i18n.t('action_type.edit'),
      remove: i18n.t('action_type.delete')
    }
    if (this.action) {
      res = actionLabels[this.action]
    }
    return res
  }
  get currentAccountingProductString() {
    let res = '-'
    let typeLabel = {
      quantity: i18n.t('area.per_unit'),
      monthly: i18n.t('setting.setting_type.monthly'),
      day_of_month: i18n.t('setting.setting_type.day_of_month'),
      monthly_square_metre: i18n.t('setting.setting_type.monthly_square_metre'),
      day_of_month_square_metre: i18n.t('setting.setting_type.day_of_month_square_metre')
    }
    if (this.requestData.currentAccountingProduct) {
      res = `${this.requestData.currentAccountingProduct.name} ${this.requestData.currentPrice} ${this.requestData.currentAccountingProduct.unit} / ${typeLabel[this.requestData.currentType]}`
    }
    return res
  }
  get previousAccountingProductString() {
    let res = '-'
    let typeLabel = {
      quantity: i18n.t('area.per_unit'),
      monthly: i18n.t('setting.setting_type.monthly'),
      day_of_month: i18n.t('setting.setting_type.day_of_month'),
      monthly_square_metre: i18n.t('setting.setting_type.monthly_square_metre'),
      day_of_month_square_metre: i18n.t('setting.setting_type.day_of_month_square_metre')
    }
    if (this.requestData.previousAccountingProduct) {
      res = `${this.requestData.previousAccountingProduct.name} ${this.requestData.previousPrice} ${this.requestData.previousAccountingProduct.unit} / ${typeLabel[this.requestData.previousType]}`
    }
    return res
  }
  get currentAccountingProduct() {
    let res = '-'
    if (this.requestData.currentAccountingProduct) {
      res = `${this.requestData.currentAccountingProduct.name}`
    }
    return res
  }
  get previousAccountingProduct() {
    let res = '-'
    if (this.requestData.previousAccountingProduct) {
      res = `${this.requestData.previousAccountingProduct.name}`
    }
    return res
  }
  get currentPrice() {
    return this.requestData.currentPrice || 0 
  }
  get previousPrice() {
    return this.requestData.previousPrice || 0
  }
  get currentOriginalDiscount() {
    return this.requestData.currentOriginalDiscount || 0
  }
  get previousOriginalDiscount() {
    return this.requestData.previousOriginalDiscount || 0
  }
  get currentDiscountType() {
    return this.requestData.currentDiscountType || 0
  }
  get previousDiscountType() {
    return this.requestData.previousDiscountType|| 0
  }
  get diffPrice() {
    let res = 0
    res = (this.currentPrice - this.currentOriginalDiscount) - (this.previousPrice - this.previousOriginalDiscount)
    return { number: res, class: res > 0 ? "text-green-500 bg-green-50" : res < 0 ? "text-red-500 bg-red-50" : '', text: res > 0 ? '+' + res : res }
  }
  get currentType() {
    let res = '-'
    let typeLabel = {
      quantity: i18n.t('area.per_unit'),
      monthly: i18n.t('setting.setting_type.monthly'),
      day_of_month: i18n.t('setting.setting_type.day_of_month'),
      monthly_square_metre: i18n.t('setting.setting_type.monthly_square_metre'),
      day_of_month_square_metre: i18n.t('setting.setting_type.day_of_month_square_metre')
    }
    if (this.requestData.currentType) {
      res = `${typeLabel[this.requestData.currentType]}`
    }
    return res
  }
  get previousType() {
    let res = '-'
    let typeLabel = {
      quantity: i18n.t('area.per_unit'),
      monthly: i18n.t('setting.setting_type.monthly'),
      day_of_month: i18n.t('setting.setting_type.day_of_month'),
      monthly_square_metre: i18n.t('setting.setting_type.monthly_square_metre'),
      day_of_month_square_metre: i18n.t('setting.setting_type.day_of_month_square_metre')
    }
    if (this.requestData.previousType) {
      res = `${typeLabel[this.requestData.previousType]}`
    }
    return res
  }
  static async getSettingTask(id) {
    const { data } = await SettingTaskAPI.getSettingTask(id);
    return new SettingTask(data.result);
  }
  static async getSettingTasksByMarketSmall(payload) {
    const { data } = await SettingTaskAPI.getSettingTasksByMarketSmall(payload);
    return data.result;
  }
  static async getSettingTasks(payload) {
    const { data } = await SettingTaskAPI.getSettingTasks(payload);
    return data.result.map(item => new SettingTask(item));
  }
  static async createSettingTask(payload) {
    const { data } = await SettingTaskAPI.createSettingTask(payload);
    data.result = new SettingTask(data.result);
    return data.result;
  }
  static async updateSettingTask(payload) {
    const { data } = await SettingTaskAPI.updateSettingTask(payload);
    data.result = new SettingTask(data.result)
    return data.result;
  }
  static async updateSettingTasks(payload) {
    const { data } = await SettingTaskAPI.updateSettingTasks(payload);
    data.result.map(item => new SettingTask(item));
    return data.result;
  }
  static async removeSettingTask(id) {
    const { data } = await SettingTaskAPI.removeSettingTask(id);
    return new SettingTask(data.result);
  }

}
